export function formatLargeNumber(amount: number): string {
  const units = [
    { value: 1000000000000, suffix: " T" },
    { value: 1000000000, suffix: " Bn" },
    { value: 1000000, suffix: " M" },
    { value: 1000, suffix: " K" },
  ];

  for (const unit of units) {
    if (amount >= unit.value) {
      const formatted = (amount / unit.value).toFixed(2); 
      return formatted.endsWith(".00") ? Math.round(amount / unit.value) + unit.suffix : formatted + unit.suffix;
    }
  }

  return amount.toString(); 
}
